import { render, staticRenderFns } from "./CaseTimeDialog.vue?vue&type=template&id=94383764&"
import script from "./CaseTimeDialog.vue?vue&type=script&lang=ts&"
export * from "./CaseTimeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports